<template>
  <div class="inner item" >
                        
        <div >
            <p class="innerTitle title bold">{{securityItem.personName}}</p>

            <div v-for="tabitem in securityItem.accessList" :key="tabitem.personRoleId" class="horizFlex">
                <p class=" title ">{{roleName(tabitem)}}</p>
                <p class=" title margin20" v-if="tabitem.canEdit">Can Edit</p>
                <button class="linkButton linkButtonMedium" :disabled="disableEdit" v-on:click="removeitem(tabitem)">Remove</button>

            </div>
            <div v-if="securityItem.accessList.length==0">
                <p class="title">***No roles defined***</p>
            </div>
            <div v-if="inEdit">
                <p class="innerTitle title">Add New Role</p>
                
                <div class="horizFlex">
                    <label for="" class="newLabel">Role</label>
                    <select name="" id="" class='newSelect' v-model="newitem.tabName" >
                        <option v-for="role in roles" :key="role.id" :value="role.name">
                            {{role.name}}
                        </option>
                    </select>

                    <div class="horizFlex" v-if="newitem.tabName=='Club'">
                        <label for="" class="newLabel">Club</label>
                        <select name="" id="" class='newSelect' v-model="newitem.locationId" >
                            <option v-for="club in clubs" :key="club.id" :value="club.id">
                                {{club.name}}
                            </option>
                        </select>
                    </div>
                    <div class="horizFlex">
                        <input type="checkbox" class="newCheck" v-model="newitem.canEdit"/>
                        <label for="" class="newLabel">Can Edit</label>
                    </div>
                    <button class="button" v-on:click="saverole()">{{saveButtonText}}</button>
                    <button class="button" v-on:click="cancelEdit()">{{cancelButtonText}}</button>
                </div>
                
            </div>
        </div>
        

        <!-- actions -->
        <div class="actions vertFlex" v-if="!inEdit">
            <div class="horizFlex">
                <button class="button"  :disabled="disableEdit" v-on:click="addRole()">Add Role</button>
                <button class="buttonwide" :disabled="disableEdit" v-on:click="resetPassword()">Send Reset Password Email </button>
                <changepass :userEmail="securityItem.emailAddress"/>
                <button class="button" :disabled="disableEdit" v-on:click="removeAdmin()">Remove Admin</button>
            </div>
            
            <p> {{message}}</p>
        </div>
        

      <!-- REMOVE MODAL -->
      <modal ref="removeModal">
        <template v-slot:header>
          <div class="horizFlex">
            <p class="subtitlebold">Remove Role</p>
          </div>
          
        </template>

        <template v-slot:body>
          <p class="subtitle">Do you want to remove {{tabItemToRemove.tabName}} ({{tabItemToRemove.clubName}})? </p>
        </template>
        
        <template v-slot:footer>
          <div>
            <button class="button" @click="closeRemoveModal">Yes</button>
            <button class="button" @click="$refs.removeModal.closeModal()">No</button>
          </div>
        </template>
      </modal>

        <!-- REMOVE MODAL -->
      <modal ref="removeUserModal">
        <template v-slot:header>
          <div class="horizFlex">
            <p class="subtitlebold">Remove Admin User</p>
          </div>
          
        </template>

        <template v-slot:body>
          <p class="subtitle">Do you want to remove {{securityItem.personName}}? </p>
        </template>
        
        <template v-slot:footer>
          <div>
            <button class="button" @click="closeRemoveUserModal">Yes</button>
            <button class="button" @click="$refs.removeUserModal.closeModal()">No</button>
          </div>
        </template>
      </modal>

  </div>



 
</template>

<script>
import {HTTP} from '../Repository'
import linkbutton from './linkbutton.vue'
import modal from './modal.vue'
import changepass from './actions/changepassword.vue'
import tokenhelper from '../tokenhelper.js'
export default {
    mixins:[tokenhelper],
    components:{
        linkbutton,
        modal,
        changepass
    },
    name:'securityitem',
    data(){
        return{
            inEdit:false,
            message:'',
            newitem:{
                personRoleId:-1,
                tabName:'',
                locationId:-1,
                canEdit:false,
                personId:0
            },

            editButtonText:'Edit',
            saveButtonText:'Save',
            cancelButtonText:'Cancel',
            editDuesPaidText:'Dues Paid',
            isActiveText:'Is Active',

            tabItemToRemove:{},
            roles:[
                {
                    id:1,
                    name:'People'
                },
                {
                    id:2,
                    name:'Club'
                },
                {
                    id:1,
                    name:'Election'
                },
                {
                    id:4,
                    name:'Super'
                },
               
            ]
            
        }
    },
    props:{
        securityItem:{
            type:Object,
        },
        clubs:{
            type:Array,
        },
        canEdit:{
            type:String,
            default:'false'
        },
    },
    computed:{
       
    	disableEdit:function(){
            return this.canEdit=='false' || this.canEdit=='False'
        },
        
    },
    methods:{
        AddTokenToAPI(){
            var token = this.getToken()   
            HTTP.defaults.headers.post['token']=token
        },
        roleName(tabItem){
            if(tabItem.clubName==''){
                return tabItem.tabName
            }else{
                return tabItem.tabName + ' (' + tabItem.clubName + ')'
            }
        },
        beforeAPI(){
            this.message=''
        },
        resetPassword(){
            this.beforeAPI()
                let req = {
                    username:this.securityItem.emailAddress
                }
                this.AddTokenToAPI();
                HTTP.post('forgotpass',req)
                .then(response=>{
                    
                   this.message="Email sent to " + this.securityItem.emailAddress
                   console.log('added role ' + this.newitem.personRoleId)
                    
                })
                .catch(e=>{
                    console.log(e)
                });

                
            
        },
        refresh(){
            console.log('refresh')
            this.$emit('refreshdata')
        },
        addRole(){
            this.inEdit=true;
        },
        resetnewitem(){
            this.newitem={
                personRoleId:-1,
                tabName:'',
                locationId:-1,
                canEdit:false,
                personId:0
            }

        },
       cancelEdit(){
           this.inEdit=false;
           this.resetnewitem();
       },
        personShowDetail(){
            if(this.person!=undefined){
                return this.person.tag=="Detail" || this.person.tag=="Edit"
            }
        },
        personInEdit(){
            if(this.person!=undefined){
                return this.person.tag=="Edit"
            }
        },
        editperson(){

            if(this.person!=undefined){
                this.person.tag="Edit"
            }
        },
        saverole(){
            this.beforeAPI()
            //API save
            if(this.newitem!=undefined){
                this.newitem.personId=this.securityItem.personId
                let req = {
                    adminTabAccess:this.newitem
                }
                this.AddTokenToAPI();
                HTTP.post('assignadminaccess',req)
                .then(response=>{
                    
                   this.newitem.personRoleId=response.data.ResponseInteger
                   console.log('added role ' + this.newitem.personRoleId)
                    this.inEdit=false
                    this.resetnewitem();
                    this.refresh()
                })
                .catch(e=>{
                    console.log(e)
                });
            }
        },
        removeAdmin(){
            this.$refs.removeUserModal.openModal()
        },
        
        closeRemoveUserModal(){
            this.beforeAPI()
            //API save
            if(this.newitem!=undefined){
                let req = {
                    adminTabUser:this.securityItem
                }
                this.AddTokenToAPI();
                HTTP.post('removeadmin',req)
                .then(response=>{
                    this.$refs.removeUserModal.closeModal()
                    this.refresh()
                })
                .catch(e=>{
                    console.log(e)
                });
            }
        },
        removeitem(tabItem){
            this.tabItemToRemove=tabItem
            this.$refs.removeModal.openModal()
        },
        closeRemoveModal(){
            //API save
                this.tabItemToRemove.removeAccess=true
                let req = {
                    adminTabAccess:this.tabItemToRemove
                }
                this.AddTokenToAPI();
                HTTP.post('assignadminaccess',req)
                .then(response=>{
                    
                  // this.newitem.personRoleId=response.data.responseInteger
                   console.log('added role ' + this.newitem.personRoleId)
                    this.inEdit=false
                    this.$refs.removeModal.closeModal()
                    this.refresh()
                })
                .catch(e=>{
                    console.log(e)
                });

                
            
        },
        
        getRoleName(roleId){
            var i;
            for(i=0;i<this.roles.length;i++){
                var role = this.roles[i]
                if(role.id==roleId){return role.name}
            }
        },
    }
}
</script>

<style scoped>
.newLabel{
    margin:5px;
}
.newSelect{

  outline-color:rgb(238,120,45);
  outline-width:2px;
  border-radius: 5px;
  font-size:inherit;
  width:150px;
  height:30px;
  margin-bottom:5px;

}
.newCheck{
    margin:7px;
}
.bold{
    font-weight: bold;
}
.inner{
    border-radius:10px; 
    margin:10px;
    padding:0px;
    text-align: left;
    background-color: white;
}
.innerInactive{
    background-color: lightgray;
}
.innerTitle{
    font-size:x-large;
    color:rgb(0,158,192);
}
.item{
    display:flex;
    flex-direction: row;
    justify-content: space-between;
}
.paid{
    color:green;
    font-size:large;
    margin-top:27px;
    margin-left:30px;
}
.unpaid{
    color:red;
    font-size:large;
    margin-top:27px;
    margin-left:30px;
}
.inactive{
    color:rgb(53, 48, 48);
    font-size:large;
    margin-top:27px;
    margin-left:30px;
}
.title{
    grid-area:title;
    margin-left:10px;
}
.editLabel{
    width:120px;
    margin:5px;
}
.lookupSelect{
  outline-color:rgb(238,120,45);
  outline-width:2px;
  border-radius: 5px;
  font-size:inherit;
  width:200px;
  margin-bottom:5px;
}
.actions{
    grid-area:actionbutton;
    display:flex;
    flex-direction: row;

}
.button{
  background-color:rgb(0,158,192);
  color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
   margin:10px 10px 10px 10px;
   min-width: 120px;
   height:50px;
}
.buttonwide{
  background-color:rgb(0,158,192);
  color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
   margin:10px 10px 10px 10px;
   min-width: 150px;
   height:50px;
}
button:disabled{
    background-color:lightgray;
}
.isactivelabel{
    font-size:large;
    margin-top:10px;
    margin-left:30px;
}
.horizFlex{
  display:flex;
  flex-direction: row;
  
}
.vertFlex{
  display:flex;
  flex-direction: column;
  
}
.linkButton{
  background-color: transparent;
  color: rgb(0,158,192);
  font-size:small;
  border:none;
  padding:0px;
  margin-left:20px;
  text-decoration: underline;
}
.linkButtonMedium{
  font-size:medium;
  
}
.margin20{
    margin-left:20px;
}
</style>